var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAboutUsIcon = function SvgAboutUsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1AE5BE",
    d: "M10.863 28.145h10.275v1.18H10.862z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2463EB",
    fillRule: "evenodd",
    d: "M14.992 7.76a1 1 0 0 1 1-1h.017a1 1 0 0 1 0 2h-.017a1 1 0 0 1-1-1m-1.108 2.847a1 1 0 0 1 1-1H16a1 1 0 0 1 1 1v6.101h.116a1 1 0 0 1 0 2H16a1 1 0 0 1-1-1v-6.1h-.116a1 1 0 0 1-1-1M30 22.47V3H2v19.469zM30.114 1H1.886A1.89 1.89 0 0 0 0 2.886v19.697a1.89 1.89 0 0 0 1.886 1.886h10.396l-.565 2h-.73a1.877 1.877 0 0 0-1.874 1.875v1.806a1 1 0 0 0 1 1h11.775a1 1 0 0 0 1-1v-1.806a1.876 1.876 0 0 0-1.875-1.875h-.73l-.565-2h10.396A1.89 1.89 0 0 0 32 22.583V2.886A1.89 1.89 0 0 0 30.114 1",
    clipRule: "evenodd"
  })));
};
export default SvgAboutUsIcon;